import type { HingeJoint, Joint, SlideJoint } from "../types/scene";

const isScalarJoint = (joint: Joint): joint is HingeJoint | SlideJoint =>
  joint.kind === "hinge" || joint.kind === "slide";

export const getJointValuesFromMap = (joints: Record<string, Joint> | null | undefined) => {
  const values: Record<string, number> = {};
  if (!joints) return values;
  Object.values(joints).forEach((joint) => {
    values[joint.name] = isScalarJoint(joint) ? joint.ref : 0;
  });
  return values;
};
